/**
 * Determine if two devices are equal.
 * @param a The first device
 * @param b The second device
 * @returns True if the devices are equal, false otherwise
 */
export const areDevicesEqual = (a?: MediaDeviceInfo, b?: MediaDeviceInfo): boolean => {
  if (!a && !b) {
    return true;
  }

  if (!b) {
    return false;
  }

  if (!a) {
    return false;
  }

  const aLength = Object.keys(a).length;
  const bLength = Object.keys(b).length;

  if (aLength === bLength) {
    if (a.deviceId === b.deviceId && a.groupId === b.groupId && a.label === b.label && a.kind === b.kind) {
      return true;
    }
  }
  return false;
};
